import React, {useEffect, useState, useRef, forwardedRef} from 'react';
import "./About.scss"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faLightbulb, faClone, faLaptop, faHandshake} from '@fortawesome/free-solid-svg-icons'
import {motion, useAnimation} from "framer-motion";
import "./../config"
import {useTranslation} from "react-i18next";


const About = ({forwardedRef}) => {
    const {t, i18n} = useTranslation();

    const [boxSelected, setBox] = useState('1');
    const controls = useAnimation();

    const refHeaderText = useRef();
    const refServiceBox1 = useRef();
    // Intersection Observer Configuration
    const observerOptions = {
        root: null,
        rootMargin: '0px 0px', // important: needs units on all values
        threshold: 0
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, observerInstance) => {
                entries.forEach(
                    entry => {
                        if (entry.isIntersecting && entry.target.classList.contains("service__item")) {
                            //animateService(entry.target);
                            controls.start("animate");
                        } else if (entry.isIntersecting && entry.target.classList.contains("section__header")) {
                            controls.start("animate");
                            observerInstance.unobserve(refHeaderText.current);
                        }
                    }
                );
            },
            observerOptions
        );
        if (refHeaderText.current) {
            observer.observe(refHeaderText.current);
        }
        if (refServiceBox1.current) {
            observer.observe(refServiceBox1.current);
        }

    }, [refHeaderText, refServiceBox1]);

    return (
        <div className="about__container" ref={forwardedRef}>
            <motion.div variants={global.config.animations.containerStagger} initial="initial" animate={controls}>

                <motion.div className="about__container--1">
                    <motion.div className="section__header" ref={refHeaderText}
                                variants={global.config.animations.fadeInText}>
                        <div className="section__header--line blue"></div>
                        <h5 className="section__header--title blue">CHI SIAMO</h5>
                    </motion.div>
                    <motion.div className="section__text" variants={global.config.animations.fadeInText}>
                        <motion.p>
                            <strong>Studio Signorello</strong>, nasce nel <strong>1988</strong> a <strong>Belpasso
                            (CT)</strong>, specializzandosi inizialmente nella <strong>progettazione
                            impiantistica</strong> e nella <strong>prevenzione incendi</strong>.<br/><br/>
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla
                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                            mollit anim id
                            est laborum. <br/><br/>
                            Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                            consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu
                            fugiat nulla
                            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
                            mollit anim id
                            est laborum.
                        </motion.p>

                        <motion.div className="about__image">
                            <img src={require('./../assets/images/office.jfif')} alt="office"/>
                        </motion.div>
                    </motion.div>
                </motion.div>


                <div className="container__clients">
                    <div className="slide-track">
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-belpasso.png')} height="100" alt="logo comune Belpasso"/>
                            <div>{t('comuneBelpasso')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-bronte.png')} height="100" alt="logo comune Bronte"/>
                            <div>{t('comuneBronte')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-misterbianco.jpg')} height="100" alt="logo comune Misterbianco"/>
                            <div>{t('comuneMisterbianco')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-paterno.png')} height="100" alt="logo comune Paternò"/>
                            <div>{t('comunePaterno')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-biancavilla.png')} height="100" alt="logo comune Biancavilla"/>
                            <div>{t('comuneBiancavilla')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-messina.png')} height="100" alt="logo comune Messina"/>
                            <div>{t('comuneMessina')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-terna-spa.png')} height="100" alt="logo Terna SpA"/>
                            <div>{t('ternaSpa')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-cardillo.png')} height="100" alt="logo Cardillo Alluminio"/>
                            <div>{t('cardilloAlluminio')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-belpasso.png')} height="100" alt="logo comune Belpasso"/>
                            <div>{t('comuneBelpasso')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-bronte.png')} height="100" alt="logo comune Bronte"/>
                            <div>{t('comuneBronte')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-misterbianco.jpg')} height="100" alt="logo comune Misterbianco"/>
                            <div>{t('comuneMisterbianco')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-paterno.png')} height="100" alt="logo comune Paternò"/>
                            <div>{t('comunePaterno')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-biancavilla.png')} height="100" alt="logo comune Biancavilla"/>
                            <div>{t('comuneBiancavilla')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-comune-messina.png')} height="100" alt="logo comune Messina"/>
                            <div>{t('comuneMessina')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-terna-spa.png')} height="100" alt="logo Terna SpA"/>
                            <div>{t('ternaSpa')}</div>
                        </div>
                        <div className="slide--client">
                            <img src={require('./../assets/images/logo-cardillo.png')} height="100" alt="logo Cardillo Alluminio"/>
                            <div>{t('cardilloAlluminio')}</div>
                        </div>
                    </div>
                </div>


            </motion.div>

            <motion.div variants={global.config.animations.containerStagger} initial="initial" animate={controls} className="about__container--2">
                <motion.h5 variants={global.config.animations.fadeInText} className="section__header--title blue services__header">{t('solutions')}</motion.h5>
                {/*<motion.div className="line__subtitle" variants={global.config.animations.fadeInText}></motion.div>*/}
                <motion.div className="service__container" variants={global.config.animations.fadeInText}>
                    <motion.div className="service__box__container">
                        <motion.div className="service__grid">
                            <motion.div className={`service__box ${boxSelected === '1' ? 'box__active' : ''}`}
                                        onClick={() => {
                                            setBox('1')
                                        }}>
                                <img src={require('./../assets/images/icons_box/lightbulb.png')} className="card__icon card__icon--1" height="100" alt="icon box1"/>
                            </motion.div>
                            <motion.div className={`service__box ${boxSelected === '2' ? 'box__active' : ''}`}
                                        onClick={() => {
                                            setBox('2')
                                        }}>
                                <img src={require('./../assets/images/icons_box/folder.png')} className="card__icon card__icon--2" height="100" alt="icon box2"/>
                            </motion.div>
                            <motion.div className={`service__box ${boxSelected === '3' ? 'box__active' : ''}`}
                                        onClick={() => {
                                            setBox('3')
                                        }}>
                                <img src={require('./../assets/images/icons_box/project.png')} className="card__icon card__icon--3" height="100" alt="icon box2"/>
                            </motion.div>
                            <div className={`service__box ${boxSelected === '4' ? 'box__active' : ''}`} onClick={() => {
                                setBox('4')
                            }}>
                                <img src={require('./../assets/images/icons_box/handshake.png')} className="card__icon card__icon--4" height="100" alt="icon box4"/>
                            </div>
                        </motion.div>
                    </motion.div>

                    <div className="service__box__container">
                        <motion.div className="service__text__box" variants={global.config.animations.containerStagger}
                                    initial="initial" animate="animate">
                            {boxSelected === '1' && (
                                <motion.div variants={global.config.animations.fadeInTextServices}>
                                    <motion.h2>Soluzione ad-hoc</motion.h2>
                                    <motion.div variants={global.config.animations.fadeInTextServices}
                                                className="service__line"></motion.div>
                                    <motion.p variants={global.config.animations.fadeInTextServices}>Nam vel eleifend que fusce
                                        consequat pretium velit vitae. Vulputate nullam pharetra lorem laoreet. Etiam
                                        sollicitudin magna nullam.
                                    </motion.p>
                                </motion.div>
                            )}
                            {boxSelected === '2' && (
                                <motion.div variants={global.config.animations.fadeInTextServices}>
                                    <motion.h2>Progettazione</motion.h2>
                                    <motion.div variants={global.config.animations.fadeInTextServices}
                                                className="service__line"></motion.div>
                                    <motion.p variants={global.config.animations.fadeInTextServices}>Nam vel eleifend que fusce
                                        consequat pretium velit vitae. Vulputate nullam pharetra lorem laoreet. Etiam
                                        sollicitudin magna nullam.
                                    </motion.p>
                                </motion.div>
                            )}
                            {boxSelected === '3' && (
                                <motion.div variants={global.config.animations.fadeInTextServices}>
                                    <motion.h2>Sviluppo</motion.h2>
                                    <motion.div variants={global.config.animations.fadeInTextServices}
                                                className="service__line"></motion.div>
                                    <motion.p variants={global.config.animations.fadeInTextServices}>Nam vel eleifend que fusce
                                        consequat pretium velit vitae. Vulputate nullam pharetra lorem laoreet. Etiam
                                        sollicitudin magna nullam.
                                    </motion.p>
                                </motion.div>
                            )}
                            {boxSelected === '4' && (
                                <motion.div variants={global.config.animations.fadeInTextServices}>
                                    <motion.h2>Soluzioni</motion.h2>
                                    <motion.div variants={global.config.animations.fadeInTextServices}
                                                className="service__line"></motion.div>
                                    <motion.p variants={global.config.animations.fadeInTextServices}>Nam vel eleifend que fusce
                                        consequat pretium velit vitae. Vulputate nullam pharetra lorem laoreet. Etiam
                                        sollicitudin magna nullam.
                                    </motion.p>
                                </motion.div>
                            )}

                        </motion.div>
                    </div>
                </motion.div>
            </motion.div>

        </div>
    );
}

export default About;
